import {
  fetchStatsByKeyActionBuilder,
  fetchStatsFromLiveApiActionBuilder,
  subscribeStatsActionBuilder,
  unsubscribeStatsActionBuilder,
  fetchStatsByWildCardActionBuilder,
} from '@ahaslides-product/frontend-toolkit'
import { liveStats } from '@/mqtt/liveStats'
import LiveStatsApi from '@/api/live-stats'
import kvSyncApi from '@/api/kvSync'
import config from '@/config'
import liveStatsPollActions from './live-stats.poll.actions'
import liveStatsScaleActions from './live-stats.scale.actions'
import liveStatsReactionActions from './live-stats.reaction.actions'

const actions = {
  fetchStatsByKeyAction: fetchStatsByKeyActionBuilder(kvSyncApi, config),
  fetchStatsByWildCardAction: fetchStatsByWildCardActionBuilder(kvSyncApi, config),
  subscribeStatsAction: subscribeStatsActionBuilder(liveStats),
  fetchStatsAction: fetchStatsFromLiveApiActionBuilder(LiveStatsApi),
  unsubscribeStatsAction: unsubscribeStatsActionBuilder(liveStats),

  ...liveStatsPollActions,
  ...liveStatsScaleActions,
  ...liveStatsReactionActions,
}

export default actions
